import React from 'react';
import PropTypes from 'prop-types';

import { getSortedServiceStopsFromTimetableServices } from 'utils/timetableServices';

import StopSummary from './StopSummary';

import { Timetable } from './StopsSummary.style';

const StopsSummary = ({ timetableServices, setIsLimitedService, originUic, destinationUic, dark }) => {
  const status = timetableServices?.[0]?.model?.serviceStatus;
  const timetableServiceStops = getSortedServiceStopsFromTimetableServices({ timetableServices });

  if (!timetableServiceStops) {
    return null;
  }

  return (
    <Timetable>
      {timetableServiceStops.map((serviceStop, index) => (
        <StopSummary
          serviceStatus={status}
          setIsLimitedService={setIsLimitedService}
          originUic={originUic}
          destinationUic={destinationUic}
          serviceStop={serviceStop}
          key={index}
          dark={dark}
        />
      ))}
    </Timetable>
  );
};

StopsSummary.propTypes = {
  dark: PropTypes.bool,
  timetableServices: PropTypes.object,
  originUic: PropTypes.string,
  destinationUic: PropTypes.string,
  setIsLimitedService: PropTypes.func
};

export default StopsSummary;
